import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseSubComponent } from '../../../shared/components';

@Component({
  selector: 'sigv-text-example',
  templateUrl: './text-example.component.html',
  styleUrls: ['./text-example.component.scss'],
})
export class TextExampleComponent extends BaseSubComponent {
  initDefaultData(): void {}

  @Input() inputTemplate!: string[];
  @Output() templateData = new EventEmitter<string>();

  pageData = {
    inputTemplate: this.inputTemplate,
  };

  pageActions = {
    clickOnTemplate: (data: string) => {
      this.templateData.emit(data);
    },
  };
}
